module.exports = __webpack_public_path__ + "images/tower.3fcb4537d54a29ee845b6eca83c0764a.png";